/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dialog_Note_CreatedInputs */

const en_dialog_note_created = /** @type {(inputs: Dialog_Note_CreatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Created`)
};

const es_dialog_note_created = /** @type {(inputs: Dialog_Note_CreatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Creada`)
};

/**
* | output |
* | --- |
* | "Created" |
*
* @param {Dialog_Note_CreatedInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const dialog_note_created = /** @type {((inputs?: Dialog_Note_CreatedInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dialog_Note_CreatedInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_dialog_note_created(inputs)
	return en_dialog_note_created(inputs)
});